var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-header-detail",
      attrs: { "data-component": "booking-header-detail" },
    },
    [
      _vm.selectedHotel && _vm.dayFormat
        ? _c("booking-header-extension", [
            _c("div", { staticClass: "booking-header-extension-left" }, [
              _c("div", { staticClass: "location" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.selectedHotel.fullHotelName) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "booking-header-extension-right" }, [
              _c("div", { staticClass: "booking-header-extension-info" }, [
                _c(
                  "div",
                  { staticClass: "date-wrapper" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "date",
                        class: {
                          disabled:
                            _vm.isBookingEditMode && _vm.isMultiRoomReservation,
                        },
                        attrs: {
                          tabindex:
                            _vm.isBookingEditMode && _vm.isMultiRoomReservation
                              ? "-1"
                              : "0",
                          "aria-label": _vm.bookingDateRange({ isAria: true }),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleClick($event)
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.handleClick($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.bookingDateRange()) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isBookingEditMode &&
                    _vm.isMultiRoomReservation &&
                    !!_vm.modifyBookingPropData.ModifyReservationDateWarning
                      ? _c(
                          "v-dropdown",
                          {
                            staticClass: "tooltip tooltip-variant--date-picker",
                            attrs: {
                              "popper-class": "booking-modify-tooltip",
                              placement: "top",
                              distance: 22,
                              skidding: 0,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "popper",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tooltip-variant--date-picker tooltip-content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tooltip-header" },
                                            [
                                              _c("span", {
                                                directives: [
                                                  {
                                                    name: "close-popper",
                                                    rawName: "v-close-popper",
                                                  },
                                                ],
                                                staticClass: "icon-close",
                                                attrs: {
                                                  "aria-label":
                                                    _vm.tc("booking.close"),
                                                  tabindex: "0",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "tooltip-body" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.modifyBookingPropData
                                                      .ModifyReservationDateWarning
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1612349644
                            ),
                          },
                          [
                            _c("button", {
                              staticClass: "tooltip-icon icon-info",
                              attrs: {
                                role: "presentation",
                                "aria-label":
                                  _vm.modifyBookingPropData
                                    .ModifyReservationDateWarning,
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "marker" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "occupancy",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("edit", [
                          "guests-and-rooms",
                          $event.target,
                        ])
                      },
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.$emit("edit", [
                          "guests-and-rooms",
                          $event.target,
                        ])
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "summary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getSummaryDetails({ capitalized: true })) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }